const TYPE = '[I18N]'

export default {
    TRANSLATE: `${TYPE} TRANSLATE`,
}